module.exports = __webpack_public_path__ + "static/media/nickname.8beec12e.png";